module.exports = __webpack_public_path__ + "static/media/family_21.083c4cc6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_21.jpg
// module id = 5852
// module chunks = 0